<template>
  <div
    class="verify-banner"
    :style="{
      backgroundImage: `url(${transformImage(
        getFeUrl('/youyan-platform/png/verify-banner.png'),
        { height: 370 }
      )})`,
    }"
  >
    <div class="text-[20px] font-bold">{{ $t('tuan-dui-ren-zheng') }}</div>
    <div class="mt-[15px] w-1/2 leading-5">
      {{
        $t(
          'tuan-dui-shou-quan-shi-you-yan-ping-tai-ti-gong-gei-de-qi-shi-ye-dan-wei-tuan-dui-deng-zu-zhi-de-shou-quan-shen-he-fu-wu-wan-cheng-shou-quan-hou-de-tuan-dui-ke-yi-yi-guan-fang-shou-quan-de-tuan-dui-shen-fen-jin-hang-tuan-dui-chuang-zuo-xiang-you-shou-quan-tuan-dui-de-quan-yi-tong-guo-shou-quan-biao-shi-ke-yi-bian-bie-qi-ye-shen-fen-you-xiao-xing-jiang-dieyi-qin-quan-shi-jian-fa-sheng-de-ke-neng'
        )
      }}
    </div>
    <div class="mt-[15px]">
      <a-button type="primary" @click="open">
        {{ $t('ren-zheng-hou-quan-yi-dui-bi') }}
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useVerifyCompare } from '~/hooks/useModal/modals/verify'
const { $t } = useNuxtApp()

const open = () => {
  useVerifyCompare({ title: $t('ren-zheng-quan-yi-dui-bi') })
}
</script>

<style lang="scss" scoped>
.verify-banner {
  @apply rounded-[8px] p-[45px_86px];

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
